import { render, staticRenderFns } from "./communityPublicityManageList.vue?vue&type=template&id=7cb2af98&scoped=true"
import script from "./communityPublicityManageList.vue?vue&type=script&lang=js"
export * from "./communityPublicityManageList.vue?vue&type=script&lang=js"
import style0 from "./communityPublicityManageList.vue?vue&type=style&index=0&id=7cb2af98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb2af98",
  null
  
)

export default component.exports